import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import MultiFileUploadField from '../../../../BaseModule/Components/Form/Components/MultiFileUpload/MultiFileUploadField';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.MULTI_UPLOAD }>;
}

const MultiFileWizardUpload: React.FC<Props> = ({ item }) => {
	return (
		<MultiFileUploadField
			name={item.key}
			label={item.title}
			isRequired={item.settings?.required}
			isWrapped
		/>
	);
};

export default MultiFileWizardUpload;
